import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=297d3aa6&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=js&"
export * from "./RuleActions.vue?vue&type=script&lang=js&"
import style0 from "./RuleActions.vue?vue&type=style&index=0&id=297d3aa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d3aa6",
  null
  
)

export default component.exports